import React, { useState, useEffect } from "react"
import NetworkApi from "../../services/networks";
import UnpublishedNetworksTable from "../../tables/UnpublishedNetworksTable"
import DashboardHeader from '../../components/DashboardHeader';
import { PopupboxContainer } from 'react-popupbox';
import LetterFilter from "../../components/LetterFilter";
import Pagination from "../../components/Pagination"

function UnpublishedNetworksPage(props) {
    const [networks, setNetworks] = useState([]);
    const networkApi = new NetworkApi(props.token);
    const [search, setSearch] = useState('');
    const [searchCity, setSearchCity] = useState('');
    const [totalPages, setTotalPages] = useState(0);
    const [pageItemActive, setPageItemActive] = useState(1);
    const [activeLetter, setActiveLetter] = useState('all'); 

    const fetch = async() => {
        try {
            if(search && searchCity ){
                let response = await networkApi.searchByCity(searchCity, 'Unpublished', pageItemActive)
                    let filteredData = response.networks.filter((network) => network.name.toLowerCase().includes(search.toLowerCase()))
                    setNetworks([...filteredData]);
                    setTotalPages(response.total_pages);
            }
            else if (searchCity ) {
                let response = await  networkApi.searchByCity(searchCity, 'Unpublished', pageItemActive)
                setNetworks(response.networks);
                setTotalPages(response.total_pages);
            }
            else if (activeLetter && activeLetter !== 'all') {
                let response = await networkApi.filterByLetter('Unpublished', activeLetter, pageItemActive);
                setNetworks(response.networks);
                setTotalPages(response.total_pages);
            }   
            else if (search) {
                let response = await networkApi.search(search, 'Unpublished', pageItemActive)
                setNetworks(response.networks);
                setTotalPages(response.total_pages);
            }
            else{
                let response = await networkApi.all('Unpublished', pageItemActive)
                setNetworks(response.networks);
                setTotalPages(response.total_pages);
                if(!search && !searchCity){
                    setActiveLetter('all');
                }
            }
        } catch (error) {
            console.error(error);
            setNetworks([]);
        }
    }

    useEffect(()=>{
        fetch()
    },[search, searchCity, activeLetter, pageItemActive])

    const __handleSearch = (event) => {
        setSearch(event.target.value);
        setActiveLetter(''); 
    };

    const handleSearchByCity =(event)=>{
        let value = event.target.value;
        setSearchCity(value);
        setActiveLetter(''); 
    }
  
    const handleLetterClick = (letter) => {
        setSearch('')
        setSearchCity('')
        setPageItemActive(1); 
        if(letter === 'all'){
            setActiveLetter('all'); 
        }else{
            setActiveLetter(letter); 
        }
      };

    const handleSelectPage=(pageNumber)=>{
        setPageItemActive(pageNumber);
    }
    
    return (
        <div className='dashboard-content'>
            <DashboardHeader
                btnText="New Network" link='/network/new' />
            <div className='dashboard-content-container'>
                <div className='dashboard-content-header'>
                    <h2>Unpublished Networks</h2>
                    <div>
                        <div className='dashboard-content-search'>
                            <input
                                type='text'
                                value={search}
                                placeholder='Search by name..'
                                className='dashboard-content-input'
                                onChange={e => __handleSearch(e)} />
                        </div>
                        <div className='dashboard-content-search search-city-input'>
                            <input
                                type='text'
                                value={searchCity}
                                placeholder='Search by city..'
                                className='dashboard-content-input'
                                onChange={e => handleSearchByCity(e)} />
                        </div>
                    </div>
                </div>
                <LetterFilter activeLetter={activeLetter} onLetterClick={handleLetterClick}/>
                <div className="unpublished-networks-custom-popup">
                    <PopupboxContainer />
                </div>
                    {
                        networks.length > 0 ?
                            <UnpublishedNetworksTable networks={networks} {...props} refresh={fetch} />
                            :
                            <div className='dashboard-content-footer'>
                                <span className='empty-table'>No data</span>
                            </div>
                    }
                <Pagination totalPages={totalPages} pageItemActive={pageItemActive} handleSelectItem={handleSelectPage}/>
            </div>
        </div>
    )
}

export default UnpublishedNetworksPage
